import { Accordion, AccordionItem } from '@heroui/react';
import { Icon } from '@iconify/react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { useGetProcedureSetsQuery } from '@/patient-app-common/api/procedureApi';
import { useGetPatientQuery } from '@/patient-app-common/api/patientApi';

import { Profile } from './Profile';
import { Careplans } from './Careplans';
import { Languages } from './Languages';
import { Account } from './Account';

export function Settings() {
  const { t } = useTranslation('settings');

  const { data: patient } = useGetPatientQuery();

  const { data: procedureSets } = useGetProcedureSetsQuery();

  if (!patient) return null;

  return (
    <div className="w-full lg:w-[600px] mx-auto min-h-[100dvh] pt-8 pb-24 space-y-8">
      <Profile patient={patient} />
      <Accordion
        itemClasses={{
          title: 'font-light text-lg',
          startContent: 'text-default-700 text-2xl',
        }}
        selectionMode="multiple"
      >
        <AccordionItem
          key="procedures"
          hidden={_.size(procedureSets) <= 1}
          startContent={<Icon icon="mdi:medical-bag" />}
          title={t('settings.list.programs')}
        >
          <Careplans procedureSets={procedureSets || []} />
        </AccordionItem>
        <AccordionItem
          key="language"
          hidden={patient.languages.length <= 1}
          startContent={<Icon icon="mdi:comment-text" />}
          title={t('common.select.language')}
        >
          <Languages
            languageId={patient.languageId}
            languages={patient.languages}
          />
        </AccordionItem>
        <AccordionItem
          key="account"
          startContent={<Icon icon="mdi:cellphone-settings" />}
          title={t('settings.list.app_settings')}
        >
          <Account patient={patient} />
        </AccordionItem>
      </Accordion>
    </div>
  );
}
